import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/Rx';
import { Observable } from "rxjs";

@Injectable()
export class PrintService {

	closePrintPreviewSource = new BehaviorSubject<boolean>(null);
  closePrintPreviewStream = this.closePrintPreviewSource.asObservable();

  constructor() { }

}


// WEBPACK FOOTER //
// ./src/app/services/print.service.ts